export default __webpack_public_path__ + "static/media/UNICEF-color.6a7d4840.png";